import register from 'ShopUiBundle/modules/app/registry';
import 'ShopUiBundle/components/molecules/language-navigation';

import './style.scss';

// tslint:disable-next-line
register('language-dropdown', () => import(/* webpackMode: "lazy" */'./language-dropdown'));
